export const keys = {
  get: 'get_deployment_module_recommender',
};
